import React, {useState} from "react";
import {Link} from "react-router-dom";
import ContactUsModal from "./ContactUsModal";

const Footer = () => {
	const [showContactModal, setShowContactModal] = useState(false);
	const [titleModal, setTitleModal] = useState(null);

	return (
		<footer className="footer bg-dark text-white py-5">
			<div className="container">
				<div className="row g-4">
					<div className="col-lg-3">
						<div className="mb-3">
							<img src={`${process.env.PUBLIC_URL}/img/footer-logo.png`} alt="JobSiteRating Logo" />
						</div>
						<p className="text-muted mb-3">Empowering contractors with honest, anonymous reviews about job sites and working conditions.</p>
						<div className="d-flex gap-3 mb-3 stats-container">
							<div>
								<div className="fw-bold">
									<span className="stat-number">50K</span>
									<span className="stat-plus">+</span>
								</div>
								<div className="small text-muted">Reviews</div>
							</div>
							<div>
								<div className="fw-bold">
									<span className="stat-number">25K</span>
									<span className="stat-plus">+</span>
								</div>
								<div className="small text-muted">Locations</div>
							</div>
							<div>
								<div className="fw-bold">
									<span className="stat-number">15K</span>
									<span className="stat-plus">+</span>
								</div>
								<div className="small text-muted">Contractors</div>
							</div>
						</div>
					</div>
					<div className="col-lg-9">
						<div className="row">
							<div className="col-lg-4 text-end">
								<h5 className="fw-bold mb-3">Platform</h5>
								<ul className="list-unstyled">
									<li className="mb-2">
										{/* <button className="text-muted text-decoration-none footer-link-btn">How It Works</button> */}
										{/* <a href={`${HOME_URL}/how-it-works`} className="text-muted text-decoration-none footer-link-btn"> */}
										<Link to={`/how-it-works`} className="text-muted text-decoration-none footer-link-btn">
											How It Works
										</Link>
									</li>
									<li className="mb-2">
										{/* <a href={`${HOME_URL}/?scroll=check-job-site`} className="text-muted text-decoration-none footer-link-btn"> */}
										<Link to={`/?scroll=check-job-site`} className="text-muted text-decoration-none footer-link-btn">
											Submit Rating
										</Link>
										{/* <button className="text-muted text-decoration-none footer-link-btn">Submit Rating</button> */}
									</li>
									<li className="mb-2">
										{/* <a href={`${HOME_URL}/?scroll=check-job-site`} className="text-muted text-decoration-none footer-link-btn"> */}
										<Link to={`/?scroll=check-job-site`} className="text-muted text-decoration-none footer-link-btn">
											Search Location
										</Link>
										{/* <button className="text-muted text-decoration-none footer-link-btn">Search Location</button> */}
									</li>
									{/* <li className="mb-2">
									<a href="/?scroll=check-job-site" className="text-muted text-decoration-none footer-link-btn">
										API Access
									</a>
								</li> */}
								</ul>
							</div>
							<div className="col-lg-4 text-end">
								<h5 className="fw-bold mb-3">Company</h5>
								<ul className="list-unstyled">
									<li className="mb-2">
										{/* <button className="text-muted text-decoration-none footer-link-btn">About Us</button> */}
										{/* <a href={`${HOME_URL}/about`} className="text-muted text-decoration-none footer-link-btn"> */}
										<Link to={`/about`} className="text-muted text-decoration-none footer-link-btn">
											About Us
										</Link>
									</li>
									<li className="mb-2">
										{/* /about */}
										{/* <a href={`${HOME_URL}/about?scroll=our-mission`} className="text-muted text-decoration-none footer-link-btn"> */}
										<Link to={`/about?scroll=our-mission`} className="text-muted text-decoration-none footer-link-btn">
											Our Mission
										</Link>
										{/* <button className="text-muted text-decoration-none footer-link-btn">Our Mission</button> */}
									</li>
									{/* <li className="mb-2">
									<button className="text-muted text-decoration-none footer-link-btn">Career</button>
								</li> */}
								</ul>
							</div>
							{/* <div className="col-lg-4 text-end">
              <h5 className="fw-bold mb-3">Support</h5>
              <ul className="list-unstyled">
                <li className="mb-2"><button className="text-muted text-decoration-none footer-link-btn">Help Center</button></li>
                <li className="mb-2"><button className="text-muted text-decoration-none footer-link-btn">Contact Us</button></li>
                <li className="mb-2"><button className="text-muted text-decoration-none footer-link-btn">Report Issue</button></li>
                <li className="mb-2"><button className="text-muted text-decoration-none footer-link-btn">Feedback</button></li>
              </ul>
            </div> */}

							<div className="col-lg-4 text-end">
								<h5 className="fw-bold mb-3">Support</h5>
								<ul className="list-unstyled">
									<li className="mb-2">
										{/* <a href="mailto:support@jobsiterating.com" className="text-muted text-decoration-none footer-link-btn">
										Help Center		
									</a> */}
										<button
											className="text-muted text-decoration-none footer-link-btn border-0 bg-transparent"
											onClick={() => {
												setShowContactModal(true);
												setTitleModal("Help Center");
											}}
											style={{cursor: "pointer"}}>
											Help Center
										</button>
									</li>

									<li className="mb-2">
										<button
											className="text-muted text-decoration-none footer-link-btn border-0 bg-transparent"
											onClick={() => {
												setShowContactModal(true);
												setTitleModal("Contact Us");
											}}
											style={{cursor: "pointer"}}>
											Contact Us
										</button>
									</li>

									<li className="mb-2">
										<button
											className="text-muted text-decoration-none footer-link-btn border-0 bg-transparent"
											onClick={() => {
												setShowContactModal(true);
												setTitleModal("Report Issue");
											}}
											style={{cursor: "pointer"}}>
											Report Issue
										</button>
										{/* <a href="mailto:support@jobsiterating.com" className="text-muted text-decoration-none footer-link-btn">
											Report Issue
										</a> */}
									</li>

									{/* <li className="mb-2">
									<a href="mailto:support@jobsiterating.com" className="text-muted text-decoration-none footer-link-btn">
										Feedback
									</a>
								</li> */}
								</ul>
							</div>
						</div>
					</div>
				</div>
				<hr className="my-4" />
				<div className="row align-items-center">
					<div className="col-md-6">
						<p className="text-muted mb-0">© 2025 JobSiteRating. All rights reserved.</p>
					</div>
					<div className="col-md-6 text-md-end">
						<Link to="/privacy-policy" className="text-muted text-decoration-none me-3 footer-link-btn">
							Privacy Policy
						</Link>
						<Link to="/terms-of-service" className="text-muted text-decoration-none me-3 footer-link-btn">
							Terms of Service
						</Link>
						<Link to="/cookie-policy" className="text-muted text-decoration-none footer-link-btn">
							Cookie Policy
						</Link>
					</div>
				</div>
			</div>
			<ContactUsModal show={showContactModal} handleClose={() => setShowContactModal(false)} titleModal={titleModal} />
		</footer>
	);
};

export default Footer;
